<template>
</template>

<script lang="ts" setup>
import {onError, onHide, onLaunch, onLoad, onShow} from "@dcloudio/uni-app";
import {useCommonStore} from "@/stores/common";
import {interceptorRequest} from "@/api";
import {interceptorAuth} from "@/common/utils/common";
import {useUserStore} from "@/stores/user";

onLaunch(() => {
  console.log("App Launch");

  interceptorRequest()
  // if (import.meta.env.VITE_ENABLE_SENTRY === 'true') {
  // //   // Sentry.init({
  // //   //     app,
  // //   //     dsn: import.meta.env.VITE_SENTRY_DSN,
  // //   //     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // //   //     // Tracing
  // //   //     tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // //   //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // //   //     tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // //   //     // Session Replay
  // //   //     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // //   //     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // //   //     environment: import.meta.env.MODE,
  // //   //     release: __APP_INFO__.fullVersion,
  // sendDefaultPii: true
  // //   // })
  //
  //   Sentry.init({
  //     dsn: import.meta.env.VITE_SENTRY_DSN,
  //     extraOptions: {
  //       onmemorywarning: false,
  //       onerror: false,
  //       transportOptions: {
  //         tunnel: "https://apm.tianzhi.xyz/tunnel",
  //       },
  //       environment: import.meta.env.MODE,
  //       release: __APP_INFO__.fullVersion,
  //     },
  //   });
  // }
  const commonStore = useCommonStore()
  const userStore = useUserStore()
  interceptorAuth(commonStore, userStore, true, undefined, false)
});

onLoad(() => {
  console.log('App Load')
})

onError((error) => {
  // Sentry.captureException(error);
  console.log('App Error: ', error)
})

onShow(() => {
  console.log("App Show");
});

onHide(() => {
  console.log("App Hide");
});

uni.onPageNotFound(() => {
  uni.showModal({
    title: '提示',
    content: '页面不存在',
    showCancel: false,
  }).then((result) => {
    uni.navigateBack({
      delta: 1
    })
  })
})

</script>
<style lang="scss">

view,
navigator,
input,
scroll-view {
  box-sizing: border-box;
}

button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 两行省略
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
